<template>
  <div>
    <section class="hero">
      <v-container class="fill-height">
        <v-row class="fill-height" align="center" justify="stretch">
          <v-col class="text-center white--text">
            <h1 class="display-2">
              {{ $t('contact.title') }}
            </h1>
            <h1>{{ $t('contact.subtitle') }}</h1>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="contact" class=" pa-3 light pa-md-10">
      <v-row>
        <v-col cols="12" lg="6" md="6">
          <v-form class="pa-3 pa-md-10 ">
            <v-text-field v-model="form.name" background-color="white" :label="$t('contact.name')" placeholder="Enter your name here"
                          outlined/>
            <v-text-field v-model="form.email" background-color="white" type="email" label="E-Mail" outlined/>
            <v-text-field v-model="form.subject" background-color="white" :label="$t('contact.subject')" outlined/>
            <v-textarea v-model="form.content" background-color="white" label="Message" outlined/>
            <v-layout justify-center>
              <v-btn class="primary" rounded text width="150" @click="handleSave">{{ $t('contact.send') }}</v-btn>
            </v-layout>
          </v-form>
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <div style="width: 100%;border: #eee 1px solid;">
            <iframe style="border: #eee 1px solid;" width="600" height="450" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" 
              src="https://maps.google.com/maps?width=600&amp;height=450&amp;hl=en&amp;q=774A%20Boulevard%20Saint-Joseph,%20Gatineau,%20Qu%C3%A9bec%20J8Y%204B9+(La%20fromentine)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
            </iframe>
          </div>
          <div>
            <v-icon color="primary" class="my-4">mdi-map-marker</v-icon>
            774A Boulevard Saint-Joseph, Gatineau, Québec J8Y 4B9
          </div>
          <div>
            <v-icon color="primary" class="my-4">mdi-phone</v-icon>
            819-777-5754
          </div>
          <div>
            <v-icon color="primary" class="my-4">mdi-email</v-icon>
            info@nomadefinir.ca
          </div>
        </v-col>
      </v-row>
    </section>
    <mail-box/>
  </div>

</template>
<script>
import { mapActions } from "vuex";
import MailBox from "../components/MailBox.vue";

export default {
  name: 'Home',
  components: {MailBox},
  data: () => ({
    fab: false,
    model: 0,
    colors: [
      'primary',
      'secondary',
      'yellow darken-2',
      'red',
      'orange',
    ],
    valid: true,
    form:{
      name: '',
      email: '',
      subject: '',
      content: ''
    },
    select: null,
  }),

  methods: {
    ...mapActions({
      saveContact: "products/saveContact"
    }),
    handleSave () {
      this.saveContact(this.form)
    }
  }

}
</script>
<style scoped>


.hero {
  height: 50vh;
  background: linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('../assets/icons/serving-dish.png') no-repeat center center;
  background-size: contain;
}
</style>
